import React from 'react'
import { createRoot } from 'react-dom/client'
import App from '@react/references/components/App'
import modal from '@scripts/components/modal'

const rootNode = document.getElementById('references-app')

const root = createRoot(rootNode)

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

modal.init()

const initialReferences = document.getElementById('initial-references').textContent
const referencesData = JSON.parse(initialReferences)

if (referencesData.selectedReference) {
  modal.openModal({
    type: 'letter',
    url: referencesData.selectedReference.url,
    defaultUrl: referencesData.url
  })
}
